/* eslint-disable react-refresh/only-export-components */
import "./global.css";

import { useEffect, useState } from "react";

import appErrorWrapper from "./AppErrorWrapper";
import CommunityHubInterest from "./components/community-hub-interest/CommunityHubInterest";
import { useFormFlowContext } from "./components/forms/FormFlowContext";
import RegistrationForm from "./components/forms/RegistrationForm";
import Header from "./components/header/Header";
import { getUserCookieData } from "./helpers/helpers";
import { validateSupporterData, validateUserCookie } from "./helpers/validationHelpers";
import appSettings from "./settings/appSettings";
import ErrorInfo from "./views/ErrorInfo";

export function App() {
  const { currentView, setNoHandshake, setUserData } = useFormFlowContext();
  const [addHeader, setHeader] = useState(false);
  const [errorScreenInfo, setErrorScreenInfo] = useState({
    display: false,
    errorType: "",
    errorCode: "error"
  });

  useEffect(() => {
    const defaultHeader = document.querySelector("#logo");
    if (!defaultHeader) {
      setHeader(true);
    }
  }, []);

  useEffect(() => {
    const widgetConfig = appSettings?.config?.widgetConfig;
    const emptyConfig =
      widgetConfig?.constructor === Object && Object.keys(widgetConfig).length === 0;

    if (!widgetConfig || emptyConfig) {
      setErrorScreenInfo((prevState) => ({
        ...prevState,
        errorKey: "noConfig",
        display: true,
        errorType: "general",
        showGoBack: false
      }));
    }
  }, []);

  useEffect(() => {
    const userCookie = getUserCookieData();
    const { handshakeRequired, supporterData, wvusLogger, hasAuth0Acct } = appSettings;

    if (validateUserCookie(userCookie) && validateSupporterData(supporterData, userCookie)) {
      setUserData({ ...userCookie, ...supporterData, hasAuth0Acct });
      return;
    }

    if (!handshakeRequired) {
      setNoHandshake(true);
    } else {
      wvusLogger.log(
        {
          errorMessage:
            "Invalid user session when validating user cookie and supporter data from the window object",
          userCookie: JSON.stringify(userCookie),
          supporterData: JSON.stringify(supporterData)
        },
        wvusLogger.getLogLevelNames().ERROR
      );

      setErrorScreenInfo((prevState) => ({
        ...prevState,
        errorKey: "noHandShake",
        display: true,
        errorType: "invalid_session",
        showGoBack: false
      }));
    }
  }, [setNoHandshake, setUserData]);

  if (errorScreenInfo.display) {
    return (
      <div>
        {addHeader && <Header />}
        <ErrorInfo {...errorScreenInfo} />
      </div>
    );
  }

  if (currentView === "community_hub_interest") {
    return (
      <div>
        {addHeader && <Header />}
        <CommunityHubInterest />
      </div>
    );
  }

  return (
    <div>
      {addHeader && <Header />}
      <RegistrationForm />
    </div>
  );
}

export default appErrorWrapper(App);
